import { render, staticRenderFns } from "./SosShiftCard.vue?vue&type=template&id=364a4520&scoped=true&lang=pug"
import script from "./SosShiftCard.vue?vue&type=script&lang=js"
export * from "./SosShiftCard.vue?vue&type=script&lang=js"
import style0 from "./SosShiftCard.vue?vue&type=style&index=0&id=364a4520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a4520",
  null
  
)

export default component.exports